//
//
//
//
//

'use strict';

import LoaderFiles from './LoaderFiles.vue'

export default {
    name: 'drop-file',
    methods: {
        drop(e) {
            e.preventDefault();
            e.stopPropagation();
            
            this.$emit('dropdone')
            //  e.dataTransfer.files - обьект типа FileList, поэтому преобразуем в обычный array.
            let arr = [];
            if (e.dataTransfer.files.length) {
                for(let i = 0; i < e.dataTransfer.files.length; i++) {
                    if (e.dataTransfer.files[i].size) arr.push(e.dataTransfer.files[i]);
                }
            }
            this.modalOpen({
                component: LoaderFiles,
                props: { files: arr }
            })
        },
        dragover(e) {
            e.preventDefault()
            e.stopPropagation()
        },
        dragleave(e) {
            this.$emit('dragleavedone')
        }
    }
}
